import { __awaiter, __generator } from "tslib";
import { getShellRenderedPromise } from '@office-start/shell-utilities-store';
import { logError } from '@office-start/telemetry-service';
export function getShellShim() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var shellRenderedPromise = getShellRenderedPromise();
                    if (shellRenderedPromise !== undefined) {
                        shellRenderedPromise
                            .then(function () {
                            return resolve(window.O365Shell);
                        })
                            .catch(function (error) {
                            reject(error);
                        });
                    }
                    else {
                        var errorMessage = 'ShellRendered promise does not exist, unable to get shell status';
                        logError({
                            eventName: 'Shell_Shim_Load',
                            errorType: 'Shell_Bootstrap_Error',
                            message: errorMessage,
                        });
                        reject(new Error(errorMessage));
                    }
                })];
        });
    });
}
//# sourceMappingURL=getShellShim.js.map